import { AriaAttributes } from 'react';

const isAriaProp = (key: string): key is keyof AriaAttributes =>
  key.startsWith('aria-');

export default <T extends AriaAttributes>(props: T) => {
  const componenyPropKeys = Object.keys(props);

  const ariaProps = componenyPropKeys.reduce<Partial<AriaAttributes>>(
    (newData, key) => {
      if (isAriaProp(key)) {
        const ariaValue = props[key];
        // type hack: TS can't infer the type for values of newData, it thinks they're undefined
        // cast this to undefined to make TS happy
        newData[key] = ariaValue as undefined;
      }
      return newData;
    },
    {},
  );

  return ariaProps;
};
